// extracted by mini-css-extract-plugin
export default {"main_Home_container":"Home_main_Home_container__r94hd"};